import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SubmitHandler, useForm } from "react-hook-form";

import useAuth from "../../hooks/useAuth";

import { EmitError } from "../../utils/EmitError";
import { ISignInData } from "../../interfaces";
import { urlHttpGov } from "../../services/urls";
import PanelUserAccessRecovery from "../../services/http/services/PanelUserAccessRecovery";
import { notification } from "antd";

export default function useForgotPassword() {
    const {
        loading: isLoadingUser,
        user,
    } = useAuth();

    const navigate = useNavigate();
    const formRef = useRef<any>(null);

    const [isSubmiting, setIsSubmiting] = useState(false);
    const [pathBackgroundImage, setPathBackgroundImage] = useState<string>('');

    const {
        control,
        handleSubmit,
        formState: { errors,  },
        reset
    } = useForm<ISignInData>({
        defaultValues: {
            email: '',
            password: '',
        }
    });

    useEffect(() => {
        if (user) {
            navigate('/usuarios/aplicativo');
        }
    }, [user, navigate]);

    const sendEmailResetPassword = useCallback(async (email: string) => {
        try {
            const response = await PanelUserAccessRecovery.sendEmailResetPassword(email);

            return response;
        } catch (err) {
            EmitError(err);
        }
    }, []);

    const onSubmit: SubmitHandler<{ email: string }> = useCallback(async (data) => {
        try {
            setIsSubmiting(true);
            const sendEmail = await sendEmailResetPassword(data.email);

            setIsSubmiting(false);

            if (!sendEmail) {
                return;
            }

            reset();

            if (sendEmail.msg) {
                notification.success({
                    message: 'Sucesso!',
                    description: sendEmail.msg,
                    placement: 'topRight',
                    duration: 8,
                })
                navigate('/?email=true');
                return;
            }

        } catch (error) {
            setIsSubmiting(false);

            EmitError(error, true, 'login_dkwdfaiweyi')
        }
    }, [navigate, reset, sendEmailResetPassword]);

    const onClickReturnToLogin = useCallback(() => {
        navigate('/');
    }, [navigate]);

    useEffect(() => {
        let dataPathBackground: string | null = localStorage.getItem('@NotaMunicipio:background');
        const defaultPath = `${urlHttpGov}/logo_county/background-default.jpg`;

        if (typeof dataPathBackground == 'string') {
            let path: string = JSON.parse(dataPathBackground).path;

            if(path.includes('undefined')) {
                path = defaultPath;
            }

            setPathBackgroundImage(path);
            return;
        }
        setPathBackgroundImage(defaultPath);
    }, []);

    return {
        isLoadingUser,
        user,
        isSubmiting,
        formRef,
        control,
        handleSubmit,
        errors,
        onSubmit,
        onClickReturnToLogin,
        pathBackgroundImage
    }
}
